import { Component, OnInit ,Input ,Output , EventEmitter,HostListener,OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css'],
})
export class TableComponent implements OnInit {
    
    isMobile: boolean;

    constructor() { }
    @HostListener('window:resize', ['$event'])
    
    onResize(event) {
        this.checkScreenSize();
    } 

    ngOnInit(): void {}
    @Input() type: any;
    @Input() title: any;
    @Input() content: any;
    @Input() data: any;
    @Input() custom: any;
    @Input() sortableColumns: any;
    @Output() sortdata = new EventEmitter<{ event: Event }>();
    @Output() link = new EventEmitter<{ event: Event }>();
    @HostListener('window:scroll', ['$event']) onScrollEvent($event){
        if(this.getYPosition($event) > 800)
          this.showbacktop = true;
        else
          this.showbacktop = false;
      }
      showbacktop: boolean = false;

    sort_obj:any = {column:'total',sort:'0'}
    selectedSortType:any = '';
    selectedSortOrder:any = '-1';

    ngOnChanges(changes: SimpleChanges): void {
        this.checkScreenSize();

         // 找到第一個有 detal.sort 屬性的項目
        const firstSortableItem = this.title.find(item => item.sort);
    
        // 如果找到，將其 sort 值賦予 selectedSortType
        this.selectedSortType = firstSortableItem ? firstSortableItem.sort : '';
    }


    getYPosition(e: Event): number {
        return (e.target as Element)['scrollingElement'].scrollTop;
    }
    

    checkScreenSize() {
        this.isMobile = window.innerWidth <= 768; // 例如：小於等於768px視為手機板
    }
 
    go_top(){
        var btn_click = document.getElementById("go_top");
        const tmp = this.getOffset(btn_click);
    	this.scrollAnimation(tmp.top,0);
    }

    getOffset (el) {
        const box = el.getBoundingClientRect();
        return{
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        }
    }

    scrollAnimation(currentY, targetY) {
        let needScrollTop = targetY - currentY
        let _currentY = currentY
        setTimeout(() => {
            const dist = Math.ceil(needScrollTop / 10)
            _currentY += dist
            window.scrollTo(_currentY, currentY)
            if (needScrollTop > 10 || needScrollTop < -10) {
                this.scrollAnimation(_currentY, targetY)
            } else {
                window.scrollTo(_currentY, targetY)
            }
        }, 10)
    }

    sort_fn(key,can_sort=1){
        if(can_sort){
            if(key==this.sort_obj.column){
                this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
            }else{
                this.sort_obj.column = key;
                this.sort_obj.sort = '0';
            }
            this.sortdata.emit(this.sort_obj);
        }
    }
    handleClick(link){
        this.link.emit(link);
    }


    cardsort_fn(key,can_sort=0){
        this.sort_obj.column = key;
        this.sort_obj.sort = can_sort;
        this.sortdata.emit(this.sort_obj);
    } 

    shouldShowMobileSortPanel(): boolean {
        return this.title && this.title.some(detal => detal.sort !== undefined && detal.sort !== null);
    }

}
